import React from 'react';
import PropTypes from 'prop-types';

function IconSelected({ color = '#88898B', size = 16, className }) {
  return (
    <svg width={size} height={size} className={className} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6.66667 11.5L4 8.52128L4.93333 7.47872L6.66667 9.41489L11.0667 4.5L12 5.54255L6.66667 11.5Z" fill="#88898B"/>
    </svg>
  )
}

IconSelected.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string
}

export default IconSelected;
